{
	"basePaths": {
		"view": {
			"production": "https://assets.change.org",
			"staging": "https://assets.staging-change.org",
			"demo": "https://assets.demo.changeeng.org"
		},
		"edit": {
			"production": "https://assets.change.org",
			"staging": "https://assets.staging-change.org",
			"demo": "https://assets.demo.changeeng.org"
		}
	}
}
